<template>
  <v-dialog v-model="isPromptVisible" persistent max-width="600px">
    <ivr-test
      @hide="hideTestInputPrompt"
      @send-test-message="_sendTestMessage"
      :is-visible="isTestInputPromptVisible"
    />
    <v-card v-if="displayMode === 'loader'">
      <div class="progressWrapper">
        <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
      </div>
    </v-card>
    <v-card v-if="displayMode === 'success'">
      <div class="progressWrapper">
        <img src="../../../../assets/images/check-mark-verified.gif" alt="" />
        <h3>Call initiated Successfully</h3>
      </div>
    </v-card>
    <v-card v-if="displayMode === 'form'">
      <v-card-title>
        <span class="headline"> Create IVR Schedule </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <div v-if="!onlySchedule" class="bulktabSwitcher">
                <div class="tabSwitcherInnerWRapper">
                  <div
                    :class="selectedGroupType === 'static' ? 'tab selected' : 'tab'"
                    @click="_selectGroupType('static')"
                  >
                    Static Groups
                  </div>
                  <div
                    :class="selectedGroupType === 'dynamic' ? 'tab selected' : 'tab'"
                    @click="_selectGroupType('dynamic')"
                  >
                    Dynamic Groups
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="selectedGroupId"
                :items="selectedGroupType === 'static' ? staticGroups : dynamicGroups"
                :label="
                  selectedGroupType === 'static'
                    ? 'Select Static Group *'
                    : 'Select Dynamic Group *'
                "
                item-text="Name"
                item-value="GroupID"
                required
                :error="!selectedGroupId && isFormDirty"
              />
            </v-col>
          </v-row>
          <v-row>
            <div class="placeHoldersWrapper">
              <div class="label">Select a template to use:</div>
              <v-autocomplete
                v-model="selectedTemplateId"
                class="filterSelector"
                :items="templates"
                label="Select Template"
                item-text="name"
                item-value="templateID"
              />
            </div>
          </v-row>
          <!--<v-row>
            <v-col cols="12">
              <v-textarea
                v-model="field.content"
                label="Content *"
                required
                counter
                :disabled="isContentDisabled"
                full-width
                single-line
              />
            </v-col>
          </v-row>-->
        </v-container>
        <message-scheduler
          :shouldSchedule.sync="shouldSchedule"
          :selectedFrequency.sync="selectedFrequency"
          :startDate.sync="startDate"
          :time.sync="time"
          :endDate.sync="endDate"
          :showToggleButton="!onlySchedule"
        />

      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" text @click="close"> Cancel </v-btn>
        <v-btn
          v-if="shouldSchedule"
          color="primary"
          text
          @click="schedule"
        >
          Schedule
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
import moment from "moment";
import { ApiCalls } from "../../../../api-calls";
import EventEmitter from "../../../../utils/event-emitter";
import Api from "../../../shared-module/api";
import MessageScheduler from "../../../shared-module/common-components/message-scheduler/message-scheduler.vue";
import UserHelper from "../../../../utils/user-helper";
import HelperMethods from "../../../../utils/helper-methods";

export default {
  name: "GroupBulkIvrComposerDialog",
  components: {
    IvrTest: () => import("../ivr-test/ivr-test.vue"),
    MessageScheduler
  },
  props: {},
  data: () => ({
    isPromptVisible: false,
    field: {
      content: "",
      signature: ""
    },
    practiceID: "",
    isFormDirty: false,
    maxMessageLength: 200,
    snackbar: false,
    notification: "Unknown",
    isTestInputPromptVisible: false,
    templates: [],
    staticGroups: [],
    selectedTemplate: null,
    selectedTemplateId: null,
    dynamicGroups: [],
    selectedGroupType: "static", // Another value 'dynamic'
    selectedGroupId: null,
    isLoading: true,
    displayMode: "loader", // Other values 'form', 'success'
    isContentDisabled: true,
    selectedFrequency: 0,
    startDate: "",
    endDate: "",
    time: "",
    shouldSchedule: false,
    onlySchedule: false,
    selectedPracticeId: null
  }),

  watch: {
    selectedTemplateId(val) {
      if (val > 0) {
        const template = this.templates.find(t => t.templateID === val);
        if (template) {
          this.selectedTemplate = template;
          this.isContentDisabled = this._determineContentDisability(template);
          return;
        }
      }
      this.isContentDisabled = true;
      this.selectedTemplate = null;
      this.field.content = "";
    },
    '$store.state.posActivePractice': function () {
      this._loadMetadata();
    },
    selectedPracticeId(val) {
      console.log("selectedPracticeId :>> ", val);
    },
    isPromptVisible(val) {
      if (!val) {
        this._reset();
      }
    }
  },

  created() {
    this._loadMetadata();
    EventEmitter.subscribe("show-group-bulk-ivr-composer", payload => {
      console.log("payload", payload);
      this.isPromptVisible = true;
      this.selectedGroupType = "static";
      if (payload) {
        if (payload.onlySchedule) {
          this.onlySchedule = true;
          this.shouldSchedule = true;
          this.selectedGroupType = "dynamic";
        } else {
          this.onlySchedule = false;
          this.shouldSchedule = false;
        }
        console.log("payload :>> ", payload);
        if (payload.practiceId) {
          this.selectedPracticeId = payload.practiceId;
        }
        if (payload.selectedGroupType && payload.selectedGroupType.length) {
          this.selectedGroupType = payload.selectedGroupType;
        }
        if (payload.selectedGroup) {
          this.selectedGroupId = payload.selectedGroup.GroupID;
        }
        if (payload.selectedTemplate) {
          this.selectedTemplateId = payload.selectedTemplate.templateID;
        }
      }
      this._loadMetadata({ practiceId: payload ? payload.practiceId : null });
    });
    EventEmitter.subscribe("hide-group-bulk-ivr-composer", () => {
      this.isPromptVisible = false;
    });
  },

  methods: {
    /**
     * To fetch all the groups and templates to show in the form
     */
    async _loadMetadata({ practiceId = null } = {}) {
      // if (this.$store.state.posActivePractice.value) {
        this.displayMode = "loader";
        const storePracticeId = this._getPracticeIdFromStore();
        if (!practiceId && storePracticeId) {
          practiceId = storePracticeId;
        }
        try {
          await Promise.allSettled([
            this._fetchStaticGroups(),
            this._fetchDynamicGroups(practiceId),
            this._fetchPracticeTemplates(practiceId)
          ]);
          this.displayMode = "form";
        } catch (error) {
          console.log("error :>> ", error);
          setTimeout(() => {
            this.isPromptVisible = false;
          }, 1000);
        }
      // }
    },

    async _fetchStaticGroups() {
      try {
        const storePracticeId = this._getPracticeIdFromStore();
        const { data } = await ApiCalls.fetchGroups(storePracticeId);
        this.staticGroups = data;
      } catch (error) {
        console.log("error", error);
      }
    },

    async _fetchDynamicGroups(practiceId) {
      let dynamicGroups = [];
      try {
        const storePracticeId = this._getPracticeIdFromStore();
        if (practiceId || storePracticeId) {
          const { data } = await Api.practiceGroup.private.fetch(practiceId || storePracticeId);
          dynamicGroups = data;
        } else {
          const { data } = await ApiCalls.fetchDynamicGroups();
          dynamicGroups = data;
        }
      } catch (error) {
        console.log("error", error);
      }
      this.dynamicGroups = dynamicGroups;
    },

    async _fetchPracticeTemplates(practiceId) {
      let practiceTemplates = [];
      try {
        const storePracticeId = this._getPracticeIdFromStore();
        const finalPracticeId = practiceId || storePracticeId;
        if (!finalPracticeId) {
          return;
        }
        console.log('finalPracticeId :>> ', finalPracticeId);
        const { data } = await Api.template.private.fetchPracticeTemplates({
          templateCategoryId: this.onlySchedule ? 0 : 3,
          practiceId: practiceId || storePracticeId
        });
        practiceTemplates = data;
      } catch (error) {
        console.log("error", error);
      }
      this.templates = this._filterTemplates(practiceTemplates);
    },

    _determineContentDisability(selectedTemplate) {
      if (
        selectedTemplate &&
        selectedTemplate.templateCategoryID &&
        selectedTemplate.templateCategoryID === 3
      ) {
        return false;
      }
      return true;
    },
    _filterTemplates(templates = []) {
      let filteredTemplates = templates.filter(t => t.templateTypeID === 3);
      if (!this.onlySchedule) {
        filteredTemplates = filteredTemplates.filter(
          template => template.templateCategoryID !== 2 && template.templateCategoryID !== 1
        );
      }
      return filteredTemplates;
    },

    _selectGroupType(groupType) {
      this.selectedGroupType = groupType;
      this.selectedGroupId = null;
    },

    _getPracticeIdFromStore() {
      let practiceId = null;
      if (this.$store.state.posActivePractice && this.$store.state.posActivePractice.value) {
        practiceId = this.$store.state.posActivePractice.value;
      }
      return practiceId;
    },

    async send() {
      this.isFormDirty = true;
      if (!this.selectedGroupId) {
        // this.notification = "Please add a message or select a file to send";
        this.notification = "Please select a group";
        this.snackbar = true;
        return;
      }
      if (!this.selectedTemplate) {
        this.notification = "Please select a template";
        this.snackbar = true;
        return;
      }
      //if (!this.field.content.length && !this.file) {
      //  // this.notification = "Please add a message or select a file to send";
      //  this.notification = "Please add a content";
      //  this.snackbar = true;
      //  return;
      //}
      //if (!HelperMethods.validateMessagePlaceholders(this.field.content)) {
      //  this.snackbar = true;
      //  this.notification = 'First name and Last name in the same message violates HIPAA laws';
      //  return;
      //}
      this.displayMode = "loader";
      const messagePayload = {
        FlowID: this.selectedTemplate.flowID,
        ToPhoneNumbers: "",
        GroupID: this.selectedGroupId,
        FlowPhoneNumber: "+17088872527",
        Message: this.field.content,
        TemplateID: this.selectedTemplate != null ? this.selectedTemplate.templateID : null,
        TemplateName: this.selectedTemplate != null ? this.selectedTemplate.name : ''
      };
      if (this.selectedTemplate.templateCategoryID === 3) {
        messagePayload.Message = this.field.content;
      }
      if (this.selectedGroupType === "static") {
        messagePayload.GroupTypeID = "1";
        messagePayload.MessageCategoryTypeID = 3;
      } else {
        const selectedDynamicGroup = this.dynamicGroups.find(
          g => g.GroupID === this.selectedGroupId
        );
        messagePayload.MessageCategoryTypeID = selectedDynamicGroup.GroupFilterTypeID;
        messagePayload.GroupTypeID = "2";
        messagePayload.GroupFilterTypeID = selectedDynamicGroup.GroupFilterTypeID;
        messagePayload.GroupFilterTypeData1 = selectedDynamicGroup.FilterData1;
        if (selectedDynamicGroup.FilterData2) {
          messagePayload.GroupFilterTypeData2 = selectedDynamicGroup.FilterData2;
        }
      }
      messagePayload.MessageTypeID = 2; // For IVR, it's 2
      try {
        await Api.ivr.private.initiateBulkCall(messagePayload);
        // this.notification = "Call successfully initiated";
        // this.snackbar = true;
        this._showSuccessMessage("Call initiated successfully");
      } catch (error) {
        this.notification = "Unable to initiate call";
        this.snackbar = true;
      }
    },

    _reset() {
      this.field = {
        content: "",
        signature: ""
      };
      this.selectedGroupId = null;
      this.selectedGroupType = "static";
      this.isFormDirty = false;
      this.isContentDisabled = true;
      this.shouldSchedule = false;
      this.onlySchedule = false;
      this.selectedTemplate = null;
      this.selectedTemplateId = null;
    },

    _showSuccessMessage() {
      this.displayMode = "success";
      setTimeout(() => {
        this._reset();
        this.isPromptVisible = false;
      }, 2500);
    },

    _prependAreaCodeIfRequired(phoneNumber) {
      if (phoneNumber && phoneNumber.length) {
        if (phoneNumber.indexOf("+1") === 0) {
          return phoneNumber;
        } else {
          return `+1${phoneNumber}`;
        }
      }
      return null;
    },

    async _sendTestMessage(testPhone) {
      this.isTestInputPromptVisible = false;
      this.displayMode = "loader";
      const messagePayload = {
        FlowID: this.selectedTemplate.flowID,
        ToPhoneNumbers: `${this._prependAreaCodeIfRequired(testPhone)};`,
        FlowPhoneNumber: "+17088872527",
        Message: this.field.content,
        TemplateID: this.selectedTemplate != null ? this.selectedTemplate.templateID : null,
        TemplateName: this.selectedTemplate != null ? this.selectedTemplate.name : ''
      };
      if (this.selectedGroupType === "static") {
        messagePayload.GroupTypeID = "1";
        messagePayload.MessageCategoryTypeID = 3;
      } else {
        const selectedDynamicGroup = this.dynamicGroups.find(
          g => g.GroupID === this.selectedGroupId
        );
        messagePayload.MessageCategoryTypeID = selectedDynamicGroup.GroupFilterTypeID;
        messagePayload.GroupTypeID = "2";
        messagePayload.GroupFilterTypeID = selectedDynamicGroup.GroupFilterTypeID;
        messagePayload.GroupFilterTypeData1 = selectedDynamicGroup.FilterData1;
        if (selectedDynamicGroup.FilterData2) {
          messagePayload.GroupFilterTypeData2 = selectedDynamicGroup.FilterData2;
        }
      }
      try {
        await Api.ivr.private.initiateCall(messagePayload);
        this.notification = "Test call successfully initiated";
        this.snackbar = true;
      } catch (error) {
        this.notification = "Unable to initiate call";
        this.snackbar = true;
      }
      this.displayMode = "form";
    },

    showTestInputPrompt() {
      this.isFormDirty = true;
      if (!this.selectedTemplate) {
        this.notification = "Please select a template";
        this.snackbar = true;
        return;
      }

      if (!HelperMethods.validateMessagePlaceholders(this.field.content)) {
        this.snackbar = true;
        this.notification = 'First name and Last name in the same message violates HIPAA laws';
        return;
      }

      //if (!this.field.content.length && !this.file) {
      //  // this.notification = "Please add a message or select a file to send";
      //  this.notification = "Please add a content";
      //  this.snackbar = true;
      //  return;
      //}
      this.isTestInputPromptVisible = true;
    },

    hideTestInputPrompt() {
      this.isTestInputPromptVisible = false;
    },

    close() {
      this.isPromptVisible = false;
      this._reset();
    },

    async schedule() {
      // Check if date and time are valid
      if (!(this.startDate && this.startDate.length)) {
        this.notification = "Please provide a valid date";
        this.snackbar = true;
        return;
      }
      if (!(this.time && this.time.length)) {
        this.notification = "Please provide a valid time";
        this.snackbar = true;
        return;
      }
      const datePart = this.startDate.split("T")[0];
      const dateTime = moment(`${datePart} ${this.time}`, "YYYY-MM-DD LT", true);
      let endDateTime = null;
      if (this.endDate) {
        const endDatePart = this.endDate.split("T")[0];
        endDateTime = moment(`${endDatePart} ${this.time}`, "YYYY-MM-DD LT", true);
      }
      if (!dateTime.isValid()) {
        this.notification = "Please select a valid time";
        this.snackbar = true;
        return;
      }
      if (!this.selectedGroupId) {
        // this.notification = "Please add a message or select a file to send";
        this.notification = "Please select a group";
        this.snackbar = true;
        return;
      }
      if (!this.selectedTemplate) {
        this.notification = "Please select a template";
        this.snackbar = true;
        return;
      }
      //if (!this.field.content.length && !this.file) {
      //  // this.notification = "Please add a message or select a file to send";
      //  this.notification = "Please add a content";
      //  this.snackbar = true;
      //  return;
      //}
      if (!HelperMethods.validateMessagePlaceholders(this.field.content)) {
        this.snackbar = true;
        this.notification = 'First name and Last name in the same message violates HIPAA laws';
        return;
      }
      this.displayMode = "loader";
      const messagePayload = {
        StartDate: dateTime,
        FlowID: this.selectedTemplate.flowID,
        ToPhoneNumbers: "",
        GroupID: this.selectedGroupId,
        FlowPhoneNumber: "+17088872527",
        Message: "",
        TemplateID: this.selectedTemplate != null ? this.selectedTemplate.templateID : null,
        TemplateName: this.selectedTemplate != null ? this.selectedTemplate.name : '',
      };
      if (endDateTime) {
        messagePayload.EndDate = endDateTime;
      }
      if (this.selectedPracticeId) {
        messagePayload.practiceId = this.selectedPracticeId;
      }
      if (this.selectedFrequency > 0) {
        messagePayload.Recurring = this.selectedFrequency;
      }
      if (this.selectedTemplate.templateCategoryID === 3) {
        messagePayload.Message = this.field.content;
      }
      if (this.selectedTemplate) {
        messagePayload.MessageCategoryTypeID = this.selectedTemplate.templateCategoryID;
      } else {
        messagePayload.MessageCategoryTypeID = 3;
      }
      if (this.selectedGroupType === "static") {
        messagePayload.GroupTypeID = "1";
        messagePayload.MessageCategoryTypeID = 3;
      } else {
        const selectedDynamicGroup = this.dynamicGroups.find(
          g => g.GroupID === this.selectedGroupId
        );
        messagePayload.GroupTypeID = "2";
        messagePayload.MessageCategoryTypeID = selectedDynamicGroup.GroupFilterTypeID;
        messagePayload.GroupFilterTypeID = selectedDynamicGroup.GroupFilterTypeID;
        messagePayload.GroupFilterTypeData1 = selectedDynamicGroup.FilterData1;
        if (selectedDynamicGroup.FilterData2) {
          messagePayload.GroupFilterTypeData2 = selectedDynamicGroup.FilterData2;
        }
      }
      messagePayload.MessageTypeID = 2; // For IVR, it's 2
      try {
        await Api.ivr.private.schedule(messagePayload).then(x => {
          this.$forceUpdate();
        });
        this._showSuccessMessage("Message scheduled successfully");
        EventEmitter.dispatch("message-scheduled");
        // this.notification = "Call successfully scheduled";
        // this.snackbar = true;
      } catch (error) {
        this.notification = "Unable to schedule call";
        this.snackbar = true;
      }
      // // const formattedDateTime = `${moment(this.startDate).format('MM/DD/YYYY')} ${moment(this.time, 'h:mm a').format('HH:mm')}`
      // if (!this.selectedGroupId) {
      //   // this.notification = "Please add a message or select a file to send";
      //   this.notification = "Please select a group";
      //   this.snackbar = true;
      //   return;
      // }
      // if (!this.field.message.length) {
      //   // this.notification = "Please add a message or select a file to send";
      //   this.notification = "Please add a message";
      //   this.snackbar = true;
      //   return;
      // }
      // this.displayMode = "loader";
      // let mediaUrl = "";
      // if (this.file) {
      //   mediaUrl = await this.uploadFile();
      // } else if (
      //   this.selectedTemplateMediaUrl &&
      //   this.selectedTemplateMediaUrl.length
      // ) {
      //   mediaUrl = this.selectedTemplateMediaUrl;
      // }
      // const activeClinic = UserHelper.getActiveClinic();
      // const activePracticeId = activeClinic.PracticeID;
      // let campaignName = this.field.name;
      // if (!(campaignName && campaignName.length)) {
      //   campaignName = `${activePracticeId}-${+new Date()}`;
      // }
      // const messagePayload = {
      //   Message: this.field.message,
      //   Signiture: this.field.signature,
      //   CampaignName: campaignName,
      //   TwilioSID: this.twilioSid,
      //   PracticeID: activePracticeId,
      //   GroupID: this.selectedGroupId,
      //   StartDate: dateTime,
      //   EndDate: endDateTime,
      // };
      // if (this.selectedFrequency > 0) {
      //   messagePayload.Recurring = this.selectedFrequency;
      // }
      // if (mediaUrl && mediaUrl.length) {
      //   messagePayload.MediaURL = mediaUrl;
      // }
      // if (this.selectedGroupType === "static") {
      //   messagePayload.GroupTypeID = "1";
      // } else {
      //   const selectedDynamicGroup = this.dynamicGroups.find(
      //     (g) => g.GroupID === this.selectedGroupId
      //   );
      //   messagePayload.GroupTypeID = "2";
      //   messagePayload.GroupFilterTypeID =
      //     selectedDynamicGroup.GroupFilterTypeID;
      //   messagePayload.GroupFilterTypeData1 =
      //     selectedDynamicGroup.GroupFilterTypeData1;
      //   if (selectedDynamicGroup.GroupFilterTypeData2) {
      //     messagePayload.GroupFilterTypeData2 =
      //       selectedDynamicGroup.GroupFilterTypeData2;
      //   }
      // }
      // try {
      //   await ApiCalls.scheduleMessage(messagePayload);
      //   // Success
      //   this._showSuccessMessage("Message scheduled successfully");
      //   EventEmitter.dispatch('message-scheduled')
      // } catch (error) {
      //   this.displayMode = "form";
      //   this.notification = "Unable to schedule message";
      //   this.snackbar = true;
      // }
    }
  }
};
</script>
<style lang="scss" scoped>
.placeHoldersWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px 15px;
  margin-top: 25px;
  margin-bottom: 15px;
  border: 1px solid rgb(58, 58, 58);
  border-radius: 8px;
}
.label {
  color: rgb(17, 17, 17);
  font-weight: 600;
  margin-right: 15px;
}

.dropdown {
  display: inline-block;
  position: relative;
}

.dd-button {
  display: inline-block;
  border: 1px solid gray;
  border-radius: 4px;
  padding: 4px 80px 4px 60px;
  background-color: #ffffff;
  cursor: pointer;
  font-size: 1rem;
  white-space: nowrap;
}

.dd-button:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid black;
}

.bulktabSwitcher {
  width: 100%;
  display: flex;
  margin-bottom: 1rem;
  margin-top: 1rem;
  justify-content: flex-start;
  align-items: center;
  .tabSwitcherInnerWRapper {
    padding: 5px 8px;
    border: 1px solid #050505;
    border-radius: 25px;
    display: flex;
    .tab {
      padding: 5px 15px;
      font-size: 10px;
      cursor: pointer;
      color: #161616;
      font-weight: 600;
      &.selected {
        box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.2);
        color: white;
        background-color: #1d1d1d;
        cursor: unset;
        border-radius: 25px;
      }
    }
  }
}

.dd-button:hover {
  background-color: #eeeeee;
}

.dd-input {
  display: none;
}

.dd-menu {
  position: absolute;
  top: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0;
  margin: 0 0 0 0;
  z-index: 5555555;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  list-style-type: none;
}

.dd-input + .dd-menu {
  display: none;
}

.dd-input:hover + .dd-menu {
  display: block;
}

.dd-menu li {
  width: 180px;
  padding: 0px 20px;
  cursor: pointer;
  white-space: nowrap;
}

.dd-menu li:hover {
  background-color: #f6f6f6;
}

.dd-menu li a {
  display: block;
  margin: -10px -20px;
  padding: 10px 20px;
}

.dd-menu li.divider {
  padding: 0;
  border-bottom: 1px solid #cccccc;
}
.toggleWrapper {
  display: flex;
  align-items: center;
  span {
    font-size: 1.1rem;
    margin-left: 1rem;
  }
  input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
  }
  input[type="checkbox"]:focus {
    outline: 0;
  }

  .toggle {
    height: 16px;
    width: 42px;
    border-radius: 16px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: 2px solid grey;
    background: grey;
    transition: all 0.2s ease;
  }
  .toggle:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 4px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: white;
    box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
    transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
  }
  .toggle:checked {
    border-color: rgb(0, 182, 91);
    background: rgb(0, 185, 108);
  }
  .toggle:checked:after {
    transform: translatex(20px);
  }
}
</style>
<style lang="scss">
.vdatetime-input {
  border-bottom: 2px solid black;
}
.fileWrapper {
  margin: 15px 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 7px 25px;
  border: 1px solid rgb(0, 182, 91);
  border-radius: 4px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.15);
  .filePart {
    flex: 7;
    display: flex;
    align-items: center;
    .iconWrapper {
      margin-right: 12px;
      color: rgb(0, 182, 91);
      * {
        color: rgb(0, 182, 91);
      }
    }
    .nameWrapper {
      margin-top: 3px;
      font-size: 0.9rem;
      font-weight: 400;
      line-height: 18px;
      .fileSize {
        font-size: 0.7rem;
        font-weight: 600;
      }
    }
  }
  .actionPart {
    flex: 3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .changeBtn {
      background-color: rgb(56, 179, 255);
      padding: 0px 15px;
      cursor: pointer;
      font-weight: 600;
      color: white;
      * {
        font-size: 1.3rem;
        color: white;
        margin-top: -4px;
      }
      border-radius: 50px;
      font-size: 0.8rem;
    }
    .removeBtn {
      cursor: pointer;
      * {
        color: rgb(251, 59, 59);
      }
    }
  }
}
.uploadBtn {
  margin: 15px 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 7px 25px;
  justify-content: center;
  cursor: pointer;
  border: 1px solid rgb(0, 182, 91);
  border-radius: 4px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.15);
  .iconWrapper {
    margin-right: 12px;
    color: rgb(0, 182, 91);
    * {
      color: rgb(0, 182, 91);
    }
  }
  .labelWrapper {
    color: rgb(0, 182, 91);
    margin-top: 3px;
    font-size: 0.9rem;
    font-weight: 400;
  }
  &:hover {
    box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.088);
  }
}
.vue__time-picker.time-picker {
  border: none !important;
  border-bottom: 2px solid black !important;
  width: 12.5em !important;
  input {
    height: 1.6em !important;
    border: none !important;
    outline: none !important;
  }
}
.progressWrapper {
  width: 100%;
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  .spinner {
    margin-left: 0rem !important;
  }
  flex-direction: column;
  img {
    margin-bottom: 25px;
  }
}
</style>
